import React, { useEffect, useRef } from 'react';
import './PageHero.css';

const PageHero = ({ title, image }) => {
  const bgRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!bgRef.current) return;
      const rect = bgRef.current.parentElement.getBoundingClientRect();
      if (rect.bottom < 0) return;
      bgRef.current.style.transform = `translateY(${window.scrollY * 0.2}px)`;
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="page-hero">
      <img
        ref={bgRef}
        src={image}
        alt=""
        aria-hidden="true"
        className="page-hero-bg"
      />
      <div className="page-hero-overlay" />
      <div className="page-hero-content">
        <h1 className="page-hero-title">{title}</h1>
      </div>
    </div>
  );
};

export default PageHero;
